import { render, staticRenderFns } from "./MbScuolaSelectField.vue?vue&type=template&id=50cf37f0&"
import script from "./MbScuolaSelectField.vue?vue&type=script&lang=js&"
export * from "./MbScuolaSelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports